"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
var csod = require("player-core");
function viewSF() {
    var _this = this;
    return {
        constructor: function (props) {
            _this.state = {};
        },
        mounted: function () {
        },
        events: {
            uploadFile: function (files) {
                var _a = _this.props, guid = _a.guid, sizeLimit = _a.sizeLimit, onSuccess = _a.onSuccess, onError = _a.onError, accept = _a.accept, maxFileNameLength = _a.maxFileNameLength, onLoadingChanged = _a.onLoadingChanged, onChangeSpinnerText = _a.onChangeSpinnerText;
                if (!files || files.length === 0) {
                    return false;
                }
                else if (sizeLimit && files[0].size > sizeLimit) {
                    var fileSizeErrorMessage = _this.props.fileSizeErrorMessage;
                    var sizeLimitMB = Math.floor(sizeLimit / 1000000).toString() + 'MB';
                    fileSizeErrorMessage = fileSizeErrorMessage.replace('{0}', sizeLimitMB);
                    onError(null, fileSizeErrorMessage, _this.props.fileUploadId);
                }
                else if (maxFileNameLength && files[0].name.length > maxFileNameLength) {
                    var fileNameLengthErrorMessage = _this.props.fileNameLengthErrorMessage;
                    fileNameLengthErrorMessage = fileNameLengthErrorMessage.replace('{0}', maxFileNameLength.toString());
                    onError(null, fileNameLengthErrorMessage, _this.props.fileUploadId);
                }
                else if (!isFileTypeValid(files[0], accept)) {
                    var fileTypeErrorMessage = _this.props.fileTypeErrorMessage;
                    var typesMessage = accept.join(', ');
                    fileTypeErrorMessage = fileTypeErrorMessage.replace('{0}', typesMessage);
                    onError(null, fileTypeErrorMessage, _this.props.fileUploadId);
                }
                else {
                    onLoadingChanged(true);
                    onChangeSpinnerText(true, _this.props.parsingResumeText);
                    var service = csod.context.serviceBase + "uploader/Upload.ashx?NeatUpload_PostBackID=" + guid + "&lang=" + csod.viewModel.cultureName + "&t=Cornerstone.Social.Rules.FeedbackFileHandler%2C%20Cornerstone.Social.Rules";
                    var formData = new FormData();
                    formData.append('files[]', files[0]);
                    csod.service.post(service, formData, { headers: { "Content-Type": undefined } })
                        .then(function (data) {
                        onLoadingChanged(false);
                        onChangeSpinnerText(false);
                        onSuccess(data, _this.props.fileUploadId);
                    })
                        .catch(function (error) {
                        onLoadingChanged(false);
                        onChangeSpinnerText(false);
                        onError(error, null, _this.props.fileUploadId);
                    });
                }
            },
            onDelete: function () {
                _this.props.onDelete(_this.props.fileViewerId);
            }
        }
    };
}
exports.viewSF = viewSF;
var isFileTypeValid = function (file, acceptedTypes) {
    if (!acceptedTypes || acceptedTypes.length === 0) {
        return true;
    }
    var fileParts = file.name.split('.');
    var fileType = fileParts[fileParts.length - 1].toLowerCase();
    return acceptedTypes.some(function (t) {
        var type = t.toLowerCase().replace('.', '');
        return type === fileType;
    });
};



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/UploadViewer/ViewSF.js
// module id = 264
// module chunks = 0 2